import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { Database, ChevronRight } from "lucide-react";
import { toast } from "sonner";
import { formatApiError } from "../../context/AuthContext";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const HUMAN_LABELS = {
  profiles: "Profili (Persone & Aziende)",
  intelligence: "Intelligence (OSINT/SOCMINT/HUMINT)",
  tradeshows: "Eventi & Fiere",
  network_events: "Network Events",
  candidates: "Candidati HR",
  patents: "Brevetti",
  technologies: "Tecnologie",
  map_markers: "War Room — Marker",
  marker_details: "War Room — Dettagli",
  marker_documents: "War Room — Documenti",
  normativa: "Normativa (Dogane/Finanza/Gare)",
  training_videos: "Academy — Video",
  course_documents: "Academy — Documenti",
  knowledge_center: "Library — Knowledge",
  reports_docs: "Library — Reports",
  repository: "Library — Repository",
  dashboard_metrics: "Dashboard Metrics",
  clients: "Clienti (Tenant)",
  users: "Utenti",
  collection_limits: "Limiti Visualizzazione",
};

export default function ContentsIndex() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/admin/collections`, { withCredentials: true })
      .then((r) => setCollections(r.data))
      .catch((e) => toast.error("Failed to load collections: " + formatApiError(e?.response?.data?.detail || e.message)))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="px-4 sm:px-6 lg:px-10 py-6 sm:py-8 lg:py-10 max-w-6xl">
      <header className="mb-10">
        <div className="text-[10px] tracking-[0.25em] uppercase text-[#00E5FF] mb-2">
          ADMIN · CONTENT MANAGEMENT
        </div>
        <h1 className="text-4xl font-black tracking-tight">Gestione Contenuti</h1>
        <p className="text-white/50 text-sm mt-2 max-w-xl">
          Tutte le collezioni del database. Clicca per visualizzare, creare,
          modificare o eliminare i record. Le modifiche si riflettono
          immediatamente nella vista del cliente.
        </p>
      </header>

      {loading && (
        <div className="text-white/40 text-sm">Loading collections…</div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-testid="collections-grid">
        {collections.map((c) => (
          <Link
            key={c.name}
            to={`/admin/contents/${c.name}`}
            data-testid={`collection-card-${c.name}`}
            className="group flex items-center justify-between px-5 py-4 bg-[#0A0E17] border border-white/10 hover:border-[#00E5FF]/50 hover:bg-[#00E5FF]/5 transition rounded"
          >
            <div className="flex items-center gap-3">
              <Database size={16} className="text-[#00E5FF]" />
              <div>
                <div className="text-sm font-bold text-white">
                  {HUMAN_LABELS[c.name] || c.name}
                </div>
                <div className="text-[10px] tracking-widest uppercase text-white/30">
                  {c.name} · {c.count} record
                </div>
              </div>
            </div>
            <ChevronRight size={16} className="text-white/30 group-hover:text-[#00E5FF]" />
          </Link>
        ))}
      </div>
    </div>
  );
}
